import { useAuth } from "providers/authProvider";
import LoadingScreen from "../components/loading-screen";

export const RequiredAuth = ({children} : {children:JSX.Element}) => {
    let auth = useAuth();
    // let location = useLocation();

    if (!auth.isAuthenticated()) {
        auth.signinRedirect();
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <LoadingScreen />;
    }

    return children;
};